import React from "react";

const TrendingThreeStars = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 14 15"
      fill="none"
    >
      <g clip-path="url(#clip0_20989_118972)">
        <path
          d="M5.96634 4.88235C5.96634 7.43508 3.93725 9.46417 1.38453 9.46417C3.93725 9.46417 5.96634 11.4933 5.96634 14.046C5.96634 11.4933 7.99543 9.46417 10.5482 9.46417C7.99543 9.46417 5.96634 7.43508 5.96634 4.88235ZM11.2027 3.57326C11.2027 5.01326 10.0245 6.19144 8.58453 6.19144C10.0245 6.19144 11.2027 7.36962 11.2027 8.80962C11.2027 7.36962 12.3809 6.19144 13.8209 6.19144C12.3809 6.19144 11.2027 5.01326 11.2027 3.57326ZM3.34816 6.19144C3.34816 4.75144 4.52634 3.57326 5.96634 3.57326C4.52634 3.57326 3.34816 2.39508 3.34816 0.955078C3.34816 2.39508 2.16998 3.57326 0.72998 3.57326C2.16998 3.57326 3.34816 4.75144 3.34816 6.19144Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_20989_118972">
          <rect
            width="13.0909"
            height="13.0909"
            fill="white"
            transform="translate(0.72998 0.955078)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default TrendingThreeStars;
